import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-service-objects',
  templateUrl: './service-objects.component.html',
  styleUrls: ['./service-objects.component.css']
})
export class ServiceObjectsComponent implements OnInit {
    public argType;

    argValue;

    public setting?: Setting;

    public itemsListServiceObjects: Item[] = [];

    public grid?: GridOptions;

    public searchTextButtons: FormButton[] = [
        { id: 'search', type: 'primary', icon: 'fas fa-search', onClick: () => this.searchItems() }
    ];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(1732, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadServiceObjects() {
        if (!!this.setting) {
            this.itemsListServiceObjects = await this.datatask.Post(1733, this.setting);
        }
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_serviceobjects.grid')
                .setLoadDataFunction({
                    method: 3467,
                    parameters: this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public searchItems() {
        this.loadServiceObjects();
        this.loadGrid();
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'serviceobject':
                this.stateService?.go('serviceobject', { serviceobject_keyno: '0' });
                break;
            default:
                break;
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        switch (id) {
            case 'searchtext':
                if (this.setting?.searchtext === '') {
                    this.loadServiceObjects();
                    this.loadGrid();
                }
                break;
            case 'show_all':
                this.loadServiceObjects();
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadServiceObjects();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    searchtext: string;
    argtype: string;
    argvalue: string;
    show_all: string;
    page_heading: string;
}
